import React from 'react';
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  createTheme,
  ThemeProvider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e69636',
    },
  },
});

const MultiSelectComponent = ({
  label,
  items,
  selectedIds,
  onToggle,
  placeholder,
  renderItemLabel,
  tagClassName = 'modalSelectedTag',
  showTags = true,
  fullWidth = true,
  size = 'small',
  selectAll = false,
}) => {
  const { t } = useTranslation();
  return (
    <ThemeProvider theme={theme}>
      <div className="modalSection">
        {label && <label className="modalLabel">{label}</label>}
        <Select
          MenuProps={{ autoFocus: false }}
          fullWidth={fullWidth}
          size={size}
          multiple
          value={selectedIds}
          displayEmpty
          onChange={(e) => {
            const newValues = e.target.value;

            if (newValues.includes('all-crops')) {
              if (selectedIds.length === items.length) {
                onToggle(null);
              } else {
                onToggle(items);
              }
              return;
            }

            const added = newValues.find((id) => !selectedIds.includes(id));
            const removed = selectedIds.find((id) => !newValues.includes(id));
            onToggle(added ?? removed);
          }}
          renderValue={(selected) =>
            selected.length === 0 ? (
              <span style={{ color: '#9e9e9e' }}>{placeholder}</span>
            ) : (
              `${selected.length} ${t('common.selected')}`
            )
          }
        >
          {selectAll && (
            <MenuItem key={'select-all-crops'} value={'all-crops'}>
              <Checkbox checked={selectedIds.length === items.length} />
              <ListItemText primary={'Tout sélectionner'} />
            </MenuItem>
          )}
          {items.map((item) => {
            const isSelected = selectedIds.includes(item.id);
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                sx={{
                  backgroundColor: isSelected ? 'rgba(39, 113, 52, 0.08)' : 'transparent',
                  '&:hover': {
                    backgroundColor: isSelected ? 'rgba(39, 113, 52, 0.15)' : undefined,
                  },
                }}
              >
                <Checkbox checked={isSelected} />
                <ListItemText primary={renderItemLabel(item)} />
              </MenuItem>
            );
          })}
        </Select>
        {showTags && selectedIds.length > 0 && (
          <div className="modalSelectedItems">
            {selectedIds.map((id) => {
              const item = items.find((i) => i.id === id);
              if (!item) return null;
              return (
                <span key={id} className={tagClassName}>
                  {renderItemLabel(item)}
                  <button type="button" onClick={() => onToggle(id)}>
                    <CloseIcon sx={{ fontSize: 14 }} />
                  </button>
                </span>
              );
            })}
          </div>
        )}
      </div>
    </ThemeProvider>
  );
};

export default MultiSelectComponent;
